/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Field security info
 */
export interface FieldSecurity { 
    /**
     * Field name
     */
    fieldName: string;
    /**
     * Field id
     */
    fieldId: number;
    /**
     * Field is hidden
     */
    isHidden: boolean;
    /**
     * Field is updatable
     */
    isUpdatable: boolean;
    /**
     * Is field for operator
     */
    isForOperator: boolean;
}

